
import { Vue, Options } from "vue-class-component";
import { TOGGLE_FAST_MODE, TOGGLE_FONT } from "@/store/index";

@Options({
  data() {
    const showMenu = false;
    return { showMenu };
  },
  methods: {
    onClickOutside(e: MouseEvent, el: any) {
      this.showMenu = false;
    },
    resetSession() {
      this.$store.dispatch("resetSession");
      this.showMenu = false;
    },
    toggleFastMode() {
      this.$store.commit(TOGGLE_FAST_MODE);
      // this.showMenu = false;
    },
    toggleFont() {
      this.$store.commit(TOGGLE_FONT);
    },
  },
  computed: {
    fastMode() {
      return this.$store.state.fastMode;
    },
    readableFont() {
      return this.$store.state.font === 'Avenir';
    },
  },
})
export default class MoreMenu extends Vue {}
